<div class="heading heading_standard heading_centered">
  {{ title }}
</div>
<p>
  {{ description }}
</p>
